import React from "react";
import { whatsappChatUrl } from "../../lib/whatsapp";
import { storeConfig } from "../../config/store.config";

// WhatsApp brand icon (inline SVG — no extra dependency).
const WhatsAppIcon = ({ size = 26 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.004 3c-7.17 0-12.99 5.82-12.99 12.99 0 2.29.6 4.53 1.74 6.5L3 29l6.66-1.74a12.9 12.9 0 006.34 1.62h.01c7.17 0 12.99-5.82 12.99-12.99S23.17 3 16.004 3zm0 23.79h-.01a10.75 10.75 0 01-5.48-1.5l-.39-.23-3.95 1.03 1.05-3.85-.26-.4a10.77 10.77 0 01-1.65-5.75c0-5.96 4.85-10.8 10.81-10.8 2.89 0 5.6 1.13 7.64 3.17a10.72 10.72 0 013.16 7.64c0 5.96-4.85 10.79-10.81 10.79zm5.93-8.08c-.32-.16-1.92-.95-2.22-1.06-.3-.11-.52-.16-.74.16-.22.32-.85 1.06-1.04 1.28-.19.22-.38.24-.7.08-.32-.16-1.37-.5-2.6-1.6-.96-.86-1.61-1.92-1.8-2.24-.19-.32-.02-.5.14-.66.15-.15.32-.38.48-.57.16-.19.21-.32.32-.54.11-.22.05-.4-.03-.56-.08-.16-.74-1.78-1.01-2.44-.27-.64-.54-.55-.74-.56l-.63-.01c-.22 0-.57.08-.87.4-.3.32-1.14 1.11-1.14 2.71 0 1.6 1.17 3.15 1.33 3.37.16.22 2.3 3.51 5.57 4.92.78.34 1.39.54 1.86.69.78.25 1.49.21 2.05.13.63-.09 1.92-.78 2.19-1.54.27-.76.27-1.41.19-1.54-.08-.13-.3-.21-.62-.37z" />
  </svg>
);

const FloatingWhatsApp = () => (
  <a
    href={whatsappChatUrl(`Hi ${storeConfig.storeName}, I'd like to ask about your products.`)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    data-testid="floating-whatsapp-btn"
    className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-150 hover:scale-105 sm:bottom-6 sm:right-6"
  >
    <WhatsAppIcon />
  </a>
);

export default FloatingWhatsApp;
export { WhatsAppIcon };
